import * as React from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import { useGraphQLClient } from '../../../graphql-client';
import Account from '../../../Account';
import Analytics from '../../../Engine/components/Analytics';
import IsDemo from '../../../Engine/components/IsDemo';
import AccountStoreProvider from '../provider/AccountStoreProvider';
import { GuardedApolloProvider } from '../../../GuardedApolloProvider';
import { BootstrapGate } from '@shared/ui';
import PixelPageViewWatcher from '../../../Engine/components/PixelPageViewWatcher';
import { ErrorManager } from '@entities/error';
export const Module = () => {
    const client = useGraphQLClient();
    return (React.createElement(BootstrapGate, null,
        React.createElement(ApolloProvider, { client: client },
            React.createElement(AccountStoreProvider, null,
                React.createElement(Analytics, null),
                React.createElement(IsDemo, null),
                React.createElement(PixelPageViewWatcher, null),
                React.createElement(GuardedApolloProvider, { client: client },
                    React.createElement(Account, null)),
                React.createElement(ErrorManager, null)))));
};
export default Module;
